
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Container, styled, Typography } from '@mui/material';

import { CartContent } from '@frontend/features/cart/components/CartContent';
import { useCart } from '@frontend/features/cart/components/CartContext';
import { CartCrossSellBanner } from '@frontend/features/cart/components/CartCrossSellBanner';
import { CartSummaryAndPay } from '@frontend/features/cart/components/CartSummaryAndPay';

const StyledBox = styled(Box)(({ theme }) => ({
  flex: 1,
  gap: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column'
}));

export const Cart = () => {
  const { refetch } = useCart();
  const { t } = useTranslation();

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  
  return (
    <Container maxWidth="xl">
      <Box display="flex" flexDirection="column" p={[0, 5]} gap={5} >
        <Typography variant="h6"> {t('cart.title')}</Typography>
        <Box display="flex" gap={3} alignItems="flex-start">
          <StyledBox>
            <CartContent p={0}/>
            <CartCrossSellBanner />
          </StyledBox>
          <CartSummaryAndPay />
        </Box>
      </Box>
    </Container>
  );
};
